// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dwTH","col":"styles_col__3wqqr"};